import React from 'react';
import { ApolloProvider as HooksProvider } from '@apollo/client';
import { ApolloProvider as ComponentsProvider } from '@apollo/client';
import { apolloService, createApolloClient } from '../services';

export const ApolloProvider = ( { children } ) => {
    createApolloClient();

    return (
        <HooksProvider client={ apolloService }>
            <ComponentsProvider client={ apolloService } children={ children } />
        </HooksProvider>
    );
};
